import { render, staticRenderFns } from "./BarcodeReads.vue?vue&type=template&id=284c3352&scoped=true&"
import script from "./BarcodeReads.vue?vue&type=script&lang=ts&"
export * from "./BarcodeReads.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeReads.vue?vue&type=style&index=0&id=284c3352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c3352",
  null
  
)

export default component.exports